/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBubbleMessageOff: {
  name: 'bubble-message-off';
  data: string;
} = {
  name: 'bubble-message-off',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.293 3.293a1 1 0 0 1 1.414 0l16 16a1 1 0 0 1-1.414 1.414l-16-16a1 1 0 0 1 0-1.414ZM8 5a1 1 0 0 1 1-1h11a2 2 0 0 1 2 2v10a1 1 0 1 1-2 0V6H9a1 1 0 0 1-1-1ZM3 7a1 1 0 0 1 1 1v12.234l3.248-1.949A2 2 0 0 1 8.277 18H14a1 1 0 1 1 0 2H8.277l-3.248 1.949c-1.333.8-3.029-.16-3.029-1.715V8a1 1 0 0 1 1-1Zm13 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
